import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Phone, ArrowRight } from "lucide-react";
import { Seo } from "@/lib/Seo";
import { PHONE, PHONE_TEL, EMAIL } from "@/data/content";
import { btnPrimary, btnSecondary } from "@/lib/ui";

export default function ThanksPage() {
  return (
    <>
      <Seo
        title="Bedankt voor uw aanvraag | Brandpreventie Recycling"
        description="Wij hebben uw aanvraag ontvangen en nemen zo snel mogelijk contact met u op."
      />
      <section className="flex min-h-[100svh] items-center justify-center px-4 py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="w-full max-w-xl rounded-3xl border border-[#2B9FD7]/25 bg-[#10232F]/60 p-10 text-center backdrop-blur-xl"
          data-testid="thanks-card"
        >
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#2B9FD7]/15 text-[#62C3F0]">
            <CheckCircle2 size={30} />
          </span>
          <h1 className="mt-6 font-heading text-3xl font-extrabold tracking-tight text-[#F5F7F9] sm:text-4xl">
            Bedankt voor uw aanvraag
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-[#CBD3D9]">
            Wij hebben uw gegevens in goede orde ontvangen. Een van onze specialisten beoordeelt de
            aangeleverde informatie en neemt contact met u op om de locatie, risicogebieden en
            gewenste alarmopvolging te bespreken.
          </p>
          <p className="mt-4 text-xs leading-relaxed text-[#CBD3D9]/70">
            Heeft u aanvullende plattegronden, foto's of technische informatie? Stuur deze onder
            vermelding van uw bedrijfsnaam naar{" "}
            <a href={`mailto:${EMAIL}`} className="text-[#62C3F0] underline underline-offset-2">{EMAIL}</a>.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <a href={PHONE_TEL} className={btnSecondary} data-testid="thanks-call-btn">
              <Phone size={15} /> Bel {PHONE}
            </a>
            <Link to="/" className={btnPrimary} data-testid="thanks-home-btn">
              Terug naar home <ArrowRight size={15} />
            </Link>
          </div>
        </motion.div>
      </section>
    </>
  );
}
